const SIDEBAR_COLLAPSED_SIZE = 80;
const SIDEBAR_DEFAULT_SIZE = 214;
const SIDEBAR_MAX_SIZE = 420;
const SIDEBAR_MIN_SIZE = 209;

export { SIDEBAR_COLLAPSED_SIZE, SIDEBAR_DEFAULT_SIZE, SIDEBAR_MAX_SIZE, SIDEBAR_MIN_SIZE };
